module.exports = __webpack_public_path__ + "img/share.faeb8b51.svg";